import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Multiselect from "multiselect-react-dropdown";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ADD_PACS_CONFIG, UPDATE_PACS_CONFIG } from "../../appConstants";
import axiosInstance from "../AxiosInstance/AxiosInstance";
const AddRuleModal = (props) => {
  const { editData } = props;

  const modalStyles = {
    color: "white",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    right: 0,
    width: "30%",
    padding: "2rem",
    height: "100vh",
    backdropFilter: "blur(14.5px)",
    background: "transparent",
    boxShadow: " 0 0 6px 0 rgba(149,149,149,0.5)",
  };

  const [pacstoReceived, setpacstoReceived] = useState([]);
  const [pacstoSend, setpacstoSend] = useState([]);
  const [name, setName] = useState("");
  const [error, seterror] = useState(false);
  const [id, setId] = useState("");

  console.log(props.data);

  useEffect(() => {
    if (editData) {
      setName(editData.pacs_config_name);
      setpacstoReceived(editData.recieve_from_pacs);
      setpacstoSend(editData.send_to_pacs);
      setId(editData.pacs_config_id);
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !pacstoReceived.length || !pacstoSend.length) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      const pacslist1 = JSON.stringify(pacstoReceived);
      const pacslist2 = JSON.stringify(pacstoSend);

      const filterobj = {
        name: name,
        recieve_from_pacs: pacslist1,
        send_to_pacs: pacslist2,
      };

      try {
        const response = await axiosInstance.post(
          `${ADD_PACS_CONFIG}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        setName("");
        setpacstoReceived([]);
        setpacstoSend([]);
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!name || !pacstoReceived.length || !pacstoSend.length) {
      seterror(true);
      setTimeout(() => {
        seterror(false);
      }, 2000);
      return;
    }

    const SendData = async () => {
      const pacslist1 = JSON.stringify(pacstoReceived);
      const pacslist2 = JSON.stringify(pacstoSend);

      const filterobj = {
        id: id,
        name: name,
        recieve_from_pacs: pacslist1,
        send_to_pacs: pacslist2,
      };

      try {
        const response = await axiosInstance.put(
          `${UPDATE_PACS_CONFIG}`,
          filterobj,
          {
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          }
        );
        if (response.data.success) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          props.setUpdate((state) => !state);
          setTimeout(() => {
            props.handleClose();
          }, 1000);
        } else {
          toast.error(`Error: ${response.data.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
    SendData();
  };

  const onSelect = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        id: items.id,
        name: items.name,
      });
    });
    setpacstoReceived(dummyarray);
  };
  const onRemove = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        id: items.id,
        name: items.name,
      });
    });
    setpacstoReceived(dummyarray);
  };

  const onSelect1 = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        id: items.id,
        name: items.name,
      });
    });
    setpacstoSend(dummyarray);
  };
  const onRemove1 = (selectedList) => {
    var dummyarray = [];
    selectedList.map((items) => {
      dummyarray.push({
        id: items.id,
        name: items.name,
      });
    });
    setpacstoSend(dummyarray);
  };
  return (
    <div>
      <Modal onClose={props.handleClose} open={props.ModalState}>
        <Box sx={modalStyles}>
          <div className="d-flex justify-content-between ">
            <div className="h5 font-weight-bold  mt-2">Add Rule</div>
            <div className=" ">
              <IconButton
                className="text-light"
                onClick={props.handleClose}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div
            className="font-bold mt-3"
            style={{
              color: "#12f0c1",
              fontWeight: "normal",
              fontSize: "14px",
              fontFamily: "montserrat",
            }}
          >
            PACS Config Name*
          </div>
          <div>
            <input
              className="text-input-modal mt-1"
              required
              id="name"
              label="Name"
              onChange={(e) => setName(e.target.value.trimStart())}
              value={name}
            />
            {!name && error && (
              <span className="errorStyles">NAME Required</span>
            )}
          </div>
          <div>
            <div
              className="mt-3"
              style={{
                color: "#12f0c1",
                fontWeight: "normal",
                fontSize: "14px",
                fontFamily: "montserrat",
              }}
            >
              {"Choose PACS Recipients*"}
            </div>
            <Multiselect
              options={props.data}
              className="mt-1"
              displayValue="name"
              style={{
                chips: { background: "black", fontWeight: "normal" },
                multiselectContainer: {
                  background: "#1A2C2B",
                  border: "1px solid #0f9077",
                  borderRadius: "5px",
                  outline: "none",
                },
                searchBox: {
                  border: "none",
                },
                option: {
                  background: "black",
                  color: "#FFFFFF",
                  fontWeight: "normal",
                },
              }}
              onSelect={onSelect}
              onRemove={onRemove}
              selectedValues={pacstoReceived}
            />
            {!pacstoReceived.length && error && (
              <span className="errorStyles">RECEIVE From Required</span>
            )}
          </div>
          <div>
            <div
              className=" mt-3"
              style={{
                color: "#12f0c1",
                fontWeight: "normal",
                fontSize: "14px",
                fontFamily: "montserrat",
              }}
            >
              {"Choose PACS Destinations*"}
            </div>
            <Multiselect
              options={props.data}
              displayValue="name"
              style={{
                chips: { background: "black", fontWeight: "normal" },
                searchBox: {
                  border: "none",
                },
                multiselectContainer: {
                  background: "#1A2C2B",
                  border: "1px solid #0f9077",
                  borderRadius: "5px",
                  outline: "none",
                },
                option: {
                  background: "black",
                  color: "#FFFFFF",
                  fontWeight: "normal",
                },
              }}
              onSelect={onSelect1}
              onRemove={onRemove1}
              selectedValues={pacstoSend}
            />
            {!pacstoSend.length && error && (
              <span className="errorStyles">SEND Required</span>
            )}
          </div>
          <div className=" text-center">
            <button
              className="btn-class mt-3 text-center"
              onClick={editData ? handleEditSubmit : handleSubmit}
            >
              SUBMIT
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};
export default AddRuleModal;
